import React from 'react'
import PropTypes from 'prop-types';
import _ from "underscore";

// Colour, Colour, colour, colour
// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `colour`, `iconclass`, and `text`
// are valid Blockly toolbox attributes.
const Colour = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));
    
    if (childBlocks.length > 0) {
        return (
            <category id="colour" name="Color" colour="%{BKY_COLOUR_HUE}" iconclass="category with-icon-paths snap-icon-theme_dual">{/* NOSONAR */}
                <label text="Color"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Colour.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Colour